 export default Object.freeze({
    LISTMONTH:[
        {
            monthNumber:1,
            monthName: 'Enero'
        },
        {
            monthNumber:2,
            monthName: 'Febrero'
        },
        {
            monthNumber:3,
            monthName: 'Marzo'
        },
        {
            monthNumber:4,
            monthName: 'Abril'
        },
        {
            monthNumber:5,
            monthName: 'Mayo'
        },
        {
            monthNumber:6,
            monthName: 'Junio'
        },
        {
            monthNumber:7,
            monthName: 'Julio'
        },
        {
            monthNumber:8,
            monthName: 'Agosto'
        },
        {
            monthNumber:9,
            monthName: 'Septiembre'
        },
        {
            monthNumber:10,
            monthName: 'Octubre'
        },
        {
            monthNumber:11,
            monthName: 'Noviembre'
        },
        {
            monthNumber:12,
            monthName: 'Diciembre'
        },
    ]
})
                                           